export const form = {
  formCopyLink: 'Kopieer link',
  formLinkCopied: 'Link gekopieerd!'
}
